import React, { useState } from 'react'
import './App.css'
import { Routes, Route, Link, useNavigate } from 'react-router-dom'
import { Layout, Menu, Drawer, Button, Grid, Dropdown, Avatar } from 'antd'
import {
  MenuOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  AppstoreOutlined,
  ShoppingCartOutlined,
  BarChartOutlined,
  UserOutlined,
  LogoutOutlined,
  LockOutlined,
  BarcodeOutlined
} from '@ant-design/icons'

import FactoryLogo from './Assets/LogoImg1.png'
/* Pages */
import Dashboard from './Pages/Dashboard/Dashboard'
import RawMaterialMaster from './Pages/Masters/RawMaterialMaster'
import SupplierMaster from './Pages/Masters/SupplierMaster'
import RawMaterialPurchase from './Pages/Inventory/RawMaterialPurchase'
import RawIdolProduction from './Pages/Production/RawIdolProduction'
import Coloring from './Pages/Production/Coloring'
import Orders from './Pages/Sales/Orders'
import ProductMaster from './Pages/Masters/ProductMaster'
import CityMaster from './Pages/Masters/CityMaster'
import CustomerMaster from './Pages/Masters/CustomerMaster'
import ProductRate from './Pages/Production/ProductRate'
import Stock from './Pages/Sales/Stock'
import OrderApproval from './Pages/Sales/OrderApproval'
import Delivery from './Pages/Sales/Delivery'
import SalesEntry from './Pages/Sales/SalesEntry'
import PaymentReceipt from './Pages/Sales/PaymentReceipt'
import BreakageEntry from './Pages/Sales/BreakageEntry'
import ProductionReport from './Pages/Reports/ProductionReport'
import PendingPaymentReport from './Pages/Reports/PendingPaymentReport'
import PaymentCollectionReport from './Pages/Reports/PaymentCollectionReport'
import SalesReport from './Pages/Reports/SalesReport'
import DeliveryReport from './Pages/Reports/DeliveryReport'
import ApprovalReport from './Pages/Reports/ApprovalReport'
import OrderReport from './Pages/Reports/OrderReport'
import StockReport from './Pages/Reports/StockReport'
import GenerateBarcode from './Pages/GenerateBarcode'

const { Header, Sider, Content } = Layout
const { useBreakpoint } = Grid

const AdminLayout = () => {
  const screens = useBreakpoint()
  const navigate = useNavigate()
  const isDesktop = screens.lg
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [openKeys, setOpenKeys] = useState([])


  const handleOpenChange = (keys) => {
  // allow only one submenu open at a time
  const latestOpenKey = keys.find(
    (key) => !openKeys.includes(key)
  )

  setOpenKeys(latestOpenKey ? [latestOpenKey] : [])
}


  const handleLogout = () => {
    sessionStorage.clear()
    navigate('/')
  }

  const menuItems = ( 
    <Menu mode="inline" openKeys={openKeys} onOpenChange={handleOpenChange} onClick={() => setDrawerOpen(false)}>
      <Menu.Item className="" icon={<DashboardOutlined />}>
        <Link className="navLinks" to="/dashboard">
          Dashboard
        </Link>
      </Menu.Item>

      <Menu.SubMenu icon={<DatabaseOutlined />} title="Masters">
        <Menu.Item>
          <Link className="navLinks" to="/masters/product">
            Product Master
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link className="navLinks" to="/masters/raw-material">
            Raw Material Master
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link className="navLinks" to="/masters/supplier">
            Supplier Master
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link className="navLinks" to="/masters/customer">
            Customer Master
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link className="navLinks" to="/masters/city">
            City Master
          </Link>
        </Menu.Item>
      </Menu.SubMenu>

      <Menu.SubMenu icon={<AppstoreOutlined />} title="Inventory">
        <Menu.Item>
          <Link className="navLinks" to="/inventory/purchase">
            Raw Material Purchase
          </Link>
        </Menu.Item>
      </Menu.SubMenu>

      <Menu.SubMenu icon={<AppstoreOutlined />} title="Production">
        <Menu.Item>
          <Link className="navLinks" to="/production/raw-idol">
            Raw Idol Production
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link className="navLinks" to="/production/coloring">
            Coloring
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link className="navLinks" to="/production/product-rate">
            Product Rate
          </Link>
        </Menu.Item>
      </Menu.SubMenu>

      <Menu.SubMenu icon={<ShoppingCartOutlined />} title="Sales">

        <Menu.Item>
          <Link className="navLinks" to="/sales/orders">
            Orders
          </Link>
        </Menu.Item>

        <Menu.Item>
          <Link className="navLinks" to="/sales/orders-approval">
            Order Approval
          </Link>
        </Menu.Item>

        <Menu.Item>
          <Link className="navLinks" to="/sales/delivery">
            Delivery
          </Link>
        </Menu.Item>

        <Menu.Item>
          <Link className="navLinks" to="/sales/sales-entry">
            Sales Entry
          </Link>
        </Menu.Item>

         <Menu.Item>
          <Link className="navLinks" to="/sales/breakage-entry">
            Breakage Entry
          </Link>
        </Menu.Item>

        <Menu.Item>
          <Link className="navLinks" to="/sales/stock">
            Stock
          </Link>
        </Menu.Item>

        <Menu.Item>
          <Link className="navLinks" to="/sales/pay-receipt">
            Payment Receipt
          </Link>
        </Menu.Item>
      </Menu.SubMenu>

      <Menu.SubMenu icon={<BarChartOutlined />} title="Reports">
        <Menu.Item>
          <Link className="navLinks" to="/reports/production">
            Production Report
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link className="navLinks" to="/reports/order">
            Order Report
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link className="navLinks" to="/reports/approval">
            Approval Report
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link className="navLinks" to="/reports/delivery">
            Delivery Report
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link className="navLinks" to="/reports/sales">
            Sales Report
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link className="navLinks" to="/reports/stock">
            Stock Report
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link className="navLinks" to="/reports/pay-collection">
            Payment Collection Report
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link className="navLinks" to="/reports/pending-payment">
            Pending Payment Report
          </Link>
        </Menu.Item>
      </Menu.SubMenu>

      <Menu.Item className="" icon={<BarcodeOutlined />}>
        <Link className="navLinks" to="/gen-barcode">
          Generate Barcode
        </Link>
      </Menu.Item>
    </Menu>
  )

  const userMenu = (
    <Menu>
      <Menu.Item key="change-password" icon={<LockOutlined />}>
        Change Password
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item
        key="logout"
        onClick={handleLogout}
        icon={<LogoutOutlined />}
        danger
      >
        Logout
      </Menu.Item>
    </Menu>
  )

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {isDesktop && (
        <Sider width={280} className="p-2">
          {menuItems}
        </Sider>
      )}

      <Layout>
        <Header className="app-header p-0">
          <div className="row m-0 w-100">
            {/* LEFT: Logo + Name */}
            <div className="col-10 col-md-11 header-left d-flex align-items-center">
              <img
                src={FactoryLogo}
                alt="Company Logo"
                className="header-logo"
              />
              <h3 className="header-title mb-0">
                <strong>Shree Ganesh Arts Factory</strong>
              </h3>
            </div>

            {/* RIGHT: User Avatar */}
            <div className="col-2 col-md-1 header-right d-flex justify-content-end align-items-center">
              <Dropdown
                overlay={userMenu}
                placement="bottomRight"
                trigger={['click']}
              >
                <Avatar
                  className="header-user-avatar"
                  icon={<UserOutlined />}
                />
              </Dropdown>
            </div>

            {/* MOBILE MENU BUTTON (INSIDE HEADER) */}
            {!isDesktop && (
              <div
                className="col-12 d-flex justify-content-end py-1"
                style={{ backgroundColor: '#001529' }}
              >
                <Button
                  icon={<MenuOutlined />}
                  type="primary"
                  className="mobile-menu-btn"
                  onClick={() => setDrawerOpen(true)}
                />
              </div>
            )}
          </div>
        </Header>

        {!isDesktop && (
          <Drawer
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            bodyStyle={{ padding: 0 }}
            style={{ backgroundColor: '#001529' }}
            closeIcon={
              <span style={{ color: '#fff', fontSize: '18px' }}>✕</span>
            }
          >
            {menuItems}
          </Drawer>
        )}

        <Content style={{ margin: 16, padding: 16 }}>
          <Routes>
            {/* ==========Dashboard========= */}
            <Route path="/dashboard" element={<Dashboard />} />
            {/* ==========Masters========= */}
            <Route path="/masters/product" element={<ProductMaster />} />
            <Route
              path="/masters/raw-material"
              element={<RawMaterialMaster />}
            />
            <Route path="/masters/supplier" element={<SupplierMaster />} />
            <Route path="/masters/customer" element={<CustomerMaster />} />
            <Route path="/masters/city" element={<CityMaster />} />
            {/* ==========Inventory========= */}
            <Route
              path="/inventory/purchase"
              element={<RawMaterialPurchase />}
            />
            {/* ==========Production========= */}
            <Route
              path="/production/raw-idol"
              element={<RawIdolProduction />}
            />
            <Route path="/production/coloring" element={<Coloring />} />
            <Route path="/production/product-rate" element={<ProductRate />} />
            {/* ==========Sales========= */}
            <Route path="/sales/orders" element={<Orders />} />
            <Route path="/sales/orders-approval" element={<OrderApproval />} />
            <Route path="/sales/stock" element={<Stock />} />
            <Route path="/sales/breakage-entry" element={<BreakageEntry />} />
            <Route path="/sales/delivery" element={<Delivery />} />
            <Route path="/sales/sales-entry" element={<SalesEntry />} />
            <Route path="/sales/pay-receipt" element={<PaymentReceipt />} />
            {/* ==========Reports========= */}
            <Route path="/reports/production" element={<ProductionReport />} />
            <Route path="/reports/stock" element={<StockReport />} />
            <Route path="/reports/order" element={<OrderReport />} />
            <Route path="/reports/approval" element={<ApprovalReport />} />
            <Route path="/reports/delivery" element={<DeliveryReport />} />
            <Route path="/reports/sales" element={<SalesReport />} />
            <Route
              path="/reports/pay-collection"
              element={<PaymentCollectionReport />}
            />
            <Route
              path="/reports/pending-payment"
              element={<PendingPaymentReport />}
            />
            {/* ==========Generate Barcode========= */}
            <Route path="/gen-barcode" element={<GenerateBarcode />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  )
}

export default AdminLayout
